import { useContext, useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import LeftSidePopupLayout from "../../popup/modal-layout";
import { GlobalContext } from "../../../context/Context";
import { useApiCall } from "../../custom-hooks/api-call";
import Swal from "sweetalert2";
import ChevronDownIcon from "../../icons/chevron-down";
import DataNotFound from "../../ui/loader/data-not-found";
import { FeildWraper, FormArea, SelectSearch } from "../../form/form-layout";
// import svgPaths from "./path";
import { ChevronDown, X } from "lucide-react";
import { List, SearchLg } from "./icons";

// SVG Icon Components
// function SearchLg() {
//   return (
//     <div className="relative shrink-0 size-[20px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
//         <path d={svgPaths.p22fdb270} stroke="#A4A7AE" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
//       </svg>
//     </div>
//   );
// }

// function List() {
//   return (
//     <div className="relative shrink-0 size-[24px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
//         <path d={svgPaths.p3d5cad80} stroke="#2C4DD4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
//       </svg>
//     </div>
//   );
// }

// function CurrencyDollarCircle() {
//   return (
//     <div className="relative shrink-0 size-[24px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
//         <path d={svgPaths.p1d80b700} stroke="#2C4DD4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
//       </svg>
//     </div>
//   );
// }

// function LayoutAlt() {
//   return (
//     <div className="relative shrink-0 size-[24px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
//         <path d={svgPaths.p32120280} stroke="#2C4DD4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
//       </svg>
//     </div>
//   );
// }

// function CalendarDate() {
//   return (
//     <div className="relative shrink-0 size-[24px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
//         <path d={svgPaths.p2fac4c20} stroke="#2C4DD4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
//       </svg>
//     </div>
//   );
// }

// function Hash() {
//   return (
//     <div className="relative shrink-0 size-[24px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
//         <path d={svgPaths.p6b08280} stroke="#2C4DD4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
//       </svg>
//     </div>
//   );
// }

// function Toggle03Right() {
//   return (
//     <div className="relative shrink-0 size-[24px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
//         <path d={svgPaths.p2a7b4240} stroke="#2C4DD4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
//         <path d={svgPaths.p268f0900} stroke="#2C4DD4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
//       </svg>
//     </div>
//   );
// }

// function Phone() {
//   return (
//     <div className="relative shrink-0 size-[24px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
//         <path d={svgPaths.p21691300} stroke="#2C4DD4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
//       </svg>
//     </div>
//   );
// }

// function SmallCalendar() {
//   return (
//     <div className="relative shrink-0 size-[19px]">
//       <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 19 19">
//         <path d={svgPaths.p31989a80} stroke="#414651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
//       </svg>
//     </div>
//   );
// }

const DynamicFilter = ({
  onClose,
  onSave = () => { },
  data,
  returnData = [],
  editingFilters,
  selectFilterName = "My Filter",
  saveFilter,
  apiUrl,
  saveFilterOff = false,
}) => {

  const [filters, setFilters] = useState([]);
  const [status, setStatus] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [onSaveFilter, setOnSaveFilter] = useState(saveFilter);
  const [searchedValue, setSearchedValue] = useState("");

  const searchResult = onSaveFilter ? onSaveFilter?.filter(item =>
    item.filter_name.toLowerCase().includes(searchedValue.toLowerCase())
  ) : []

  useEffect(() => {
    if (returnData?.length) {
      const merged = data.map((item) => {
        const override = returnData.find((o) => o.name === item.name);
        return override ? override : item;
      });
      setFilters(merged);
    } else {
      setFilters(data);
    }
    setDepartmentList(state?.getDropdowns?.departmentList);
  }, [data, returnData]);

  const closeFun = () => {
    setStatus(false);
    setTimeout(() => {
      onClose();
    }, 200);
  };

  const handleCheckboxToggle = (index) => {
    console.log("FUNCTION RUN")
    const updated = [...filters];
    updated[index].isChecked = !updated[index].isChecked;
    setFilters(updated);
  };

  const handleValueChange = (index, e) => {
    const updated = [...filters];
    updated[index].value = e.target.value;
    setFilters(updated);
  };

  const handleBetweenChange = (index, pos, val) => {
    const updated = [...filters];
    const current = updated[index];
    const range = [...current.value];

    // ✅ Special handling ONLY for date type
    if (current.betweenType === "date") {
      // FROM date changed
      if (pos === 0) {
        // If FROM >= TO → reset TO
        if (range[1] && val >= range[1]) {
          range[0] = val;
          range[1] = "";
        } else {
          range[0] = val;
        }

        // TO date changed
        if (pos === 1) {
          range[1] = val;
        }
      } else {
        // Non-date between (salary, number, etc.)
        range[pos] = val;
      }

      current.value = range;
      updated[index] = current;
      setFilters(updated);
    } else {
      range[pos] = val;
      updated[index].value = range;
      setFilters(updated);
    }
  };

  // const handleSubmit = () => {
  //   const formatted = filters
  //     .filter((f) => f.isChecked)
  //     .map((f) => ({
  //       ...f,
  //     }))
  //     .filter((f) => {
  //       return Array.isArray(f.value) ? (f.selectedOpt == "between") ? f.value.length > 1 : f.value.length > 0 : (f.value != "" && f.value != null && f.value != undefined)}
  //     );
  //   console.log("formatted", formatted);
  //   const filterName = saveFilterName;
  //   onSave(formatted, filterName, editingFilter);
  //   closeFun();
  // };

  const handleSubmit = () => {
    const formatted = filters
      // .filter((f) => f.isChecked)
      // .map((f) => ({
      //   ...f,
      // }))
      .filter((f) => {
        return f.value != "" && f.value != null && f.value != undefined && f.value != [] && f.value != ["", ""];
      })
      .map((f) => {
        if(Array.isArray(f.value) && f.selectedOpt == "between"){

          return (!f.value[0]) ?
            {...f, value: [f.value[1], f.value[1]]}
            :
            (!f.value[1]) ?
            {...f, value: [f.value[0], f.value[0]]}
            :
            {...f}
        }else{
          return {...f}
        }
      });
    console.log("formatted", formatted);
    const filterName = saveFilterName;
    onSave(formatted, filterName, editingFilter);
    closeFun();
  };

  const [editingFilter, setEditingFilter] = useState(editingFilters);
  const [saveFilterName, setSaveFilterName] = useState(selectFilterName);
  const [saveFilterID, setSaveFilterID] = useState(null);
  const [saveFilterIs, setSaveFilterIs] = useState(false);
  const [originalFilters, setOriginalFilters] = useState([]);
  const wrapperRef = useRef(null);

  const handleSaveFilter = async () => {
    const formatted = filters
      .filter((f) => f.isChecked)
      .map((f) => ({
        ...f,
      }))
      .filter((f) =>
        Array.isArray(f.value) ? f.value.length > 0 : f.value !== ""
      );

    if (formatted.length === 0) {
      Swal.fire(
        "No filters selected",
        "Please select and fill filters before saving.",
        "warning"
      );
      return;
    }

    // Original filter name if editing
    const originalName = editingFilter?.filterName || "";

    let confirmBtnText = editingFilter ? "Updated" : "Saved";

    const { value: filterName } = await Swal.fire({
      title: editingFilter ? "Update filter name" : "Enter filter name",
      input: "text",
      inputValue: originalName,
      inputPlaceholder: "Enter a name for this filter",
      showCancelButton: true,
      confirmButtonText: confirmBtnText,
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Filter name is required";
        }
      },
      didOpen: (popup) => {
        const input = popup.querySelector("input");
        const confirmBtn = popup.querySelector(".swal2-confirm");

        input.addEventListener("input", () => {
          if (editingFilter) {
            // Check if input differs from original
            if (input.value.trim() !== originalName.trim()) {
              confirmBtn.textContent = "Duplicate";
              confirmBtnText = "Duplicate";
            } else {
              confirmBtn.textContent = "Updated";
              confirmBtnText = "Updated";
            }
          }
        });
      },
    });

    if (!filterName) {
      return; // Cancelled or empty input
    }

    try {
      const apiData = {
        api_url: apiUrl,
        filter_name: filterName.trim(),
        filters_json: formatted,
      };

      // If editing, send filter_id too
      if (editingFilter?.filterId) {
        apiData.filter_id = editingFilter.filterId;
      }

      await apiCall({
        method: "post",
        url: "list-config/save-filters",
        data: JSON.stringify(apiData),
      });

      Swal.fire("Success", `Filter ${confirmBtnText} successfully`, "success");

      onSave(formatted, filterName.trim(), editingFilter);
      setEditingFilter(null);
    } catch (error) {
      console.warn("Error saving filter:", error);
      Swal.fire("Error", "Failed to save filter. Please try again.", "error");
    }
  };

  const handleDeletFilter = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this filter? This action cannot be undo.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      const apiData = JSON.stringify({ filter_id: id });
      await apiCall({
        method: "post",
        url: "delete-user-filter",
        data: apiData,
      });
      setOnSaveFilter((prevFilters) => prevFilters.filter((f) => f.id !== id));

      if (editingFilter?.filterId === id) {
        setEditingFilter(null); // reset editingFilter if it was deleted
        const reset = filters.map((f) => ({
          ...f,
          isChecked: false,
          value:
            f.field === "search_by_salary" ||
              f.field === "search_by_joining_date"
              ? ["", ""]
              : "",
          selectedOperator:
            f.field === "search_by_salary"
              ? "between"
              : f.field === "search_by_joining_date"
                ? "is"
                : "contains",
        }));
        setFilters(reset);
        setSaveFilterName("My Filter");
        setSaveFilterID(null);
      }
      Swal.fire("Deleted!", "Your filter has been deleted.", "success");
    } catch (error) {
      console.warn("Error deleting filter:", error);
      Swal.fire("Error", "Failed to delete filter. Please try again.", "error");
    }
  };

  const handleSaveFilterChange = (rdata, filterName, filterId) => {
    const merged = data.map((item) => {
      const override = rdata.find((o) => o.name === item.name);
      return override ? override : item;
    });

    setFilters(merged);
    setOriginalFilters(JSON.parse(JSON.stringify(merged))); // deep copy
    setEditingFilter({ filterName, filterId });
    setSaveFilterName(filterName);
  };

  // Compare function to check if filters changed
  const isFiltersChanged = () => {
    return JSON.stringify(filters) !== JSON.stringify(originalFilters);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSaveFilterIs(false);
      }
    }

    if (saveFilterIs) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [saveFilterIs]);

  //
  const getToday = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const getNextDate = (dateStr) => {
    if (!dateStr) return undefined;

    const date = new Date(dateStr);
    date.setDate(date.getDate());

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const handleClearFilters = () => {
    const reset = filters.map((f) => ({
      ...f,
      isChecked: false,
      value:
        f.field === "search_by_salary" || f.field === "search_by_joining_date"
          ? ["", ""]
          : "",
      selectedOperator:
        f.field === "search_by_salary"
          ? "between"
          : f.field === "search_by_joining_date"
            ? "is"
            : "contains",
    }));

    setFilters(reset);

    // IMPORTANT FIXES
    setEditingFilter(null); // stop edit mode
    setSaveFilterName("My Filter");
    setSaveFilterID(null);
    setOriginalFilters(JSON.parse(JSON.stringify(reset))); // reset reference

    onSave([]); // Clear filters in parent
    // closeFun(); // Optional: Close popup after clearing
  };


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const [openSections, setOpenSections] = useState({
    designation: true,
    joiningDate: true,
  });

  const [selectedDesignations, setSelectedDesignations] = useState(['Designer']);
  const [notifyTeammates, setNotifyTeammates] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const removeDesignation = (designation) => {
    setSelectedDesignations(prev => prev.filter(d => d !== designation));
  };

  const clearDesignations = () => {
    setSelectedDesignations([]);
  };

  const clearJoiningDate = () => {
    setStartDate('');
    setEndDate('');
  };

  // const handleSubmit = () => {
  //   console.log('Filters submitted:', {
  //     selectedDesignations,
  //     startDate,
  //     endDate,
  //     notifyTeammates
  //   });
  // };

  const clearSingleFilter = (index) => {
    const updated = [...filters];
    updated[index].value = "";
    setFilters(updated);
  };

  return (
    <LeftSidePopupLayout popupStatus={status} className={Style.customize_modal}>
      {/* <div className={Style.modal_header}>
        <h4>
          Table Filters
          <button onClick={closeFun} className={Style.close_btn}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
            >
              <path
                d="M1.21143 0.596189L10.4038 9.78858M1.21143 9.78858L10.4038 0.596189"
                stroke="currentColor"
                strokeWidth="1.18236"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </h4>

        {!saveFilterOff && (
          <div className={Style.myFilter}>
            <div
              ref={wrapperRef}
              className={`${Style.myFilter_main} ${
                saveFilterIs ? Style.active : ""
              }`}
            >
              <h5
                onClick={() => {
                  setSaveFilterIs(!saveFilterIs);
                }}
              >
                {saveFilterName}

                <div className={Style.dropIcon}>
                  <ChevronDownIcon />
                </div>
              </h5>

              {saveFilterIs && (
                <div className={Style.myFilter__wrap}>
                  {onSaveFilter?.length ? (
                    onSaveFilter.map((ele, idx) => {
                      return (
                        <div
                          className={`${Style.myFilter__items} ${
                            saveFilterName == ele?.filter_name
                              ? Style.isActive
                              : ""
                          }`}
                          key={ele.id || idx}
                          onClick={() => {
                            handleSaveFilterChange(
                              ele?.config_filters,
                              ele?.filter_name,
                              ele?.id
                            );
                            setSaveFilterIs(false);
                            setSaveFilterID(ele?.id);
                          }}
                        >
                          <p>{ele.filter_name}</p>
                        </div>
                      );
                    })
                  ) : (
                    <div className={Style.myFilter__items}>
                      <DataNotFound
                        title={"Filter"}
                        className={Style.noDataFound}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="flex gap-1">
              <button
                className={`${Style.myFilter_btn} ${Style.deleteBtn}`}
                onClick={() => {
                  handleDeletFilter(saveFilterID);
                }}
                disabled={saveFilterID ? false : true}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M10.9333 5.93451C10.7263 5.93451 10.5586 6.09177 10.5586 6.2858V12.9251C10.5586 13.119 10.7263 13.2764 10.9333 13.2764C11.1403 13.2764 11.308 13.119 11.308 12.9251V6.2858C11.308 6.09177 11.1403 5.93451 10.9333 5.93451Z"
                    fill="white"
                  />
                  <path
                    d="M6.5124 5.93451C6.30543 5.93451 6.1377 6.09177 6.1377 6.2858V12.9251C6.1377 13.119 6.30543 13.2764 6.5124 13.2764C6.71937 13.2764 6.88711 13.119 6.88711 12.9251V6.2858C6.88711 6.09177 6.71937 5.93451 6.5124 5.93451Z"
                    fill="white"
                  />
                  <path
                    d="M3.28981 4.96558V13.6206C3.28981 14.1321 3.4899 14.6125 3.83943 14.9572C4.18735 15.3029 4.67154 15.4991 5.17827 15.4999H12.2678C12.7747 15.4991 13.2589 15.3029 13.6067 14.9572C13.9562 14.6125 14.1563 14.1321 14.1563 13.6206V4.96558C14.8511 4.79268 15.3013 4.16339 15.2084 3.49498C15.1153 2.82671 14.508 2.32681 13.789 2.32668H11.8706V1.88757C11.8728 1.51831 11.717 1.16373 11.4382 0.902867C11.1594 0.642147 10.7806 0.496966 10.3867 0.499985H7.05941C6.66553 0.496966 6.28673 0.642147 6.0079 0.902867C5.72906 1.16373 5.57332 1.51831 5.57552 1.88757V2.32668H3.65705C2.93809 2.32681 2.3308 2.82671 2.23771 3.49498C2.14476 4.16339 2.595 4.79268 3.28981 4.96558ZM12.2678 14.7974H5.17827C4.53761 14.7974 4.03922 14.2814 4.03922 13.6206V4.99646H13.4069V13.6206C13.4069 14.2814 12.9085 14.7974 12.2678 14.7974ZM6.32493 1.88757C6.32244 1.70465 6.39914 1.5286 6.53761 1.39947C6.67593 1.27035 6.86416 1.1994 7.05941 1.20256H10.3867C10.5819 1.1994 10.7702 1.27035 10.9085 1.39947C11.047 1.52846 11.1237 1.70465 11.1212 1.88757V2.32668H6.32493V1.88757ZM3.65705 3.02925H13.789C14.1616 3.02925 14.4635 3.31234 14.4635 3.66157C14.4635 4.0108 14.1616 4.29388 13.789 4.29388H3.65705C3.28454 4.29388 2.98258 4.0108 2.98258 3.66157C2.98258 3.31234 3.28454 3.02925 3.65705 3.02925Z"
                    fill="white"
                  />
                  <path
                    d="M8.72236 5.93451C8.5154 5.93451 8.34766 6.09177 8.34766 6.2858V12.9251C8.34766 13.119 8.5154 13.2764 8.72236 13.2764C8.92933 13.2764 9.09707 13.119 9.09707 12.9251V6.2858C9.09707 6.09177 8.92933 5.93451 8.72236 5.93451Z"
                    fill="white"
                  />
                </svg>
              </button>

              <button
                className={`${Style.myFilter_btn}`}
                onClick={handleSaveFilter}
                disabled={
                  editingFilter
                    ? !isFiltersChanged() // disable if no changes
                    : filters.filter(
                        (f) =>
                          f.isChecked &&
                          (f.field === "search_by_salary"
                            ? f.value[0] || f.value[1]
                            : f.value)
                      ).length === 0
                }
              >

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M14.9302 3.9172L11.9302 1.1047C11.8835 1.06125 11.8281 1.02688 11.7671 1.00355C11.7062 0.980225 11.641 0.968401 11.5752 0.968758H1.5752C1.17737 0.968758 0.79584 1.11692 0.514535 1.38064C0.233231 1.64436 0.0751953 2.00205 0.0751953 2.37501V13.625C0.0751953 13.998 0.233231 14.3557 0.514535 14.6194C0.79584 14.8831 1.17737 15.0313 1.5752 15.0313H13.5752C13.973 15.0313 14.3546 14.8831 14.6359 14.6194C14.9172 14.3557 15.0752 13.998 15.0752 13.625V4.25001C15.0756 4.18832 15.063 4.12716 15.0381 4.07005C15.0132 4.01294 14.9765 3.961 14.9302 3.9172ZM9.5752 1.90626V4.71876H5.5752V1.90626H9.5752ZM3.5752 14.0938V10.8125C3.5752 10.6882 3.62787 10.569 3.72164 10.4811C3.81541 10.3931 3.94259 10.3438 4.0752 10.3438H11.0752C11.2078 10.3438 11.335 10.3931 11.4288 10.4811C11.5225 10.569 11.5752 10.6882 11.5752 10.8125V14.0938H3.5752ZM14.0752 13.625C14.0752 13.7493 14.0225 13.8686 13.9288 13.9565C13.835 14.0444 13.7078 14.0938 13.5752 14.0938H12.5752V10.8125C12.5752 10.4395 12.4172 10.0819 12.1359 9.81814C11.8546 9.55442 11.473 9.40626 11.0752 9.40626H4.0752C3.67737 9.40626 3.29584 9.55442 3.01454 9.81814C2.73323 10.0819 2.5752 10.4395 2.5752 10.8125V14.0938H1.5752C1.44259 14.0938 1.31541 14.0444 1.22164 13.9565C1.12787 13.8686 1.0752 13.7493 1.0752 13.625V2.37501C1.0752 2.25069 1.12787 2.13146 1.22164 2.04355C1.31541 1.95564 1.44259 1.90626 1.5752 1.90626H4.5752V4.71876C4.5752 4.9674 4.68055 5.20586 4.86809 5.38167C5.05563 5.55749 5.30998 5.65626 5.5752 5.65626H9.5752C9.84041 5.65626 10.0948 5.55749 10.2823 5.38167C10.4698 5.20586 10.5752 4.9674 10.5752 4.71876V1.90626H11.3702L14.0752 4.4422V13.625Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </div>
        )}

        <h6 className={`${saveFilterOff ? "pt-4" : ""}`}>Search By:</h6>
      </div>

      <div className={`${Style.modal_body} ${Style.filterBodyPopup}`}>
        {filters.filter((f) => f.isChecked).length ? (
          <div
            className={`${Style.filter_item_wrapper} ${
              filters.filter((f) => f.isChecked).length === filters.length
                ? Style.isAll
                : ""
            }`}
          >
            {filters.map((filter, index) => {
              return (
                filter.isChecked && (
                  <div
                    className={Style.filter_item}
                    key={`Filter_item_${index}_1`}
                  >
                    <div className={Style.filter_label}>
                      <label>
                        <input
                          type="checkbox"
                          checked={filter.isChecked}
                          onChange={() => handleCheckboxToggle(index)}
                        />
                        <b></b>
                        <span className="capitalize">
                          {filter?.label ? (
                            <>{filter?.label}</>
                          ) : (
                            <>
                              {filter?.name?.includes("_")
                                ? `${filter?.name?.replaceAll("_", " ")}`
                                : filter?.name}
                            </>
                          )}
                        </span>
                      </label>
                    </div>

                    <FormArea className="!gap-y-[10px]">
                      <>
                        {!filter?.isOptDisable ? (
                          <FeildWraper className={`!py-0 !w-[50%]`}>
                            <SelectSearch
                              menuPosition="fixed"
                              value={filter.selectedOpt}
                              onChange={(value) => {
                                const updated = [...filters];
                                updated[index].selectedOpt = value;
                                if (value === "between") {
                                  updated[index].value = ["", ""]; // reset for range inputs
                                } else {
                                  updated[index].value = ""; // single value input
                                }
                                setFilters(updated);
                              }}
                              options={[
                                {
                                  value: "is",
                                  label: "Is",
                                  isDisabled: !filter?.options?.includes("is"),
                                },
                                {
                                  value: "contains",
                                  label: "Contains",
                                  isDisabled:
                                    !filter?.options?.includes("contains"),
                                },
                                {
                                  value: "between",
                                  label: "Between",
                                  isDisabled:
                                    !filter?.options?.includes("between"),
                                },
                                {
                                  value: "start_with",
                                  label: "Start With",
                                  isDisabled:
                                    !filter?.options?.includes("start_with"),
                                },
                                {
                                  value: "end_with",
                                  label: "End With",
                                  isDisabled:
                                    !filter?.options?.includes("end_with"),
                                },
                              ]}
                              isClearable={false}
                            />
                          </FeildWraper>
                        ) : null}

                        {filter?.selectedOpt == "between" ? (
                          <div className={Style.date_range_wrapper}>
                            <FeildWraper className={"!py-0"}>
                              <input
                                type={filter?.betweenType}
                                value={filter.value[0] || ""}
                                onChange={(e) =>
                                  handleBetweenChange(index, 0, e.target.value)
                                }
                                max={
                                  filter.betweenType === "date"
                                    ? getToday()
                                    : undefined
                                }
                                placeholder={`Min ${
                                  filter?.label
                                    ? filter?.label
                                    : filter?.name?.includes("_")
                                    ? `${filter?.name?.replaceAll("_", " ")}`
                                    : filter?.name
                                }`}
                              />
                            </FeildWraper>
                            <FeildWraper className={"!py-0"}>
                              <input
                                type={filter?.betweenType}
                                value={filter.value[1] || ""}
                                min={
                                  filter.betweenType === "date"
                                    ? getNextDate(filter.value[0])
                                    : undefined
                                }
                                max={
                                  filter.betweenType === "date"
                                    ? getToday()
                                    : undefined
                                }
                                onChange={(e) =>
                                  handleBetweenChange(index, 1, e.target.value)
                                }
                                placeholder={`Max ${
                                  filter?.label
                                    ? filter?.label
                                    : filter?.name?.includes("_")
                                    ? `${filter?.name?.replaceAll("_", " ")}`
                                    : filter?.name
                                }`}
                              />
                            </FeildWraper>
                          </div>
                        ) : (
                          <FeildWraper
                            className={"!py-0"}
                            width={`${filter?.isOptDisable ? "100%" : "50%"}`}
                          >
                            {filter?.type == "dropdown" ? (
                              <>
                                <SelectSearch
                                  menuPosition="fixed"
                                  value={filter.value}
                                  onChange={(e) =>
                                    handleValueChange(index, {
                                      target: { value: e },
                                    })
                                  }
                                  multiple={filter?.isMulti || false}
                                  placeholder={`Select ${
                                    filter?.label
                                      ? filter?.label
                                      : filter?.name?.includes("_")
                                      ? filter?.name?.replaceAll("_", " ")
                                      : filter?.name
                                  }`}
                                  options={
                                    filter?.dropdown
                                      ? filter?.dropdown.map((els) => ({
                                          value: els[filter?.dropdownVal],
                                          label: els[filter?.dropdownKey],
                                        }))
                                      : departmentList?.map((els) => ({
                                          value: els?.title,
                                          label: els?.title,
                                        }))
                                  }
                                />
                              </>
                            ) : (
                              <input
                                type={filter?.type}
                                value={filter.value}
                                onChange={(e) => handleValueChange(index, e)}
                                placeholder={`${
                                  filter?.label
                                    ? filter?.label
                                    : filter?.name?.includes("_")
                                    ? `${filter?.name?.replaceAll("_", " ")}`
                                    : filter?.name
                                }`}
                              />
                            )}
                          </FeildWraper>
                        )}
                      </>
                    </FormArea>
                  </div>
                )
              );
            })}
          </div>
        ) : null}

        {filters.filter((f) => !f.isChecked).length ? (
          <div className={Style.filter_label_tag_wrap}>
            {filters.map((filter, index) => {
              return (
                !filter.isChecked && (
                  <div
                    key={`FilterItem_${index}_2`}
                    className={Style.filter_label_tag}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={filter.isChecked}
                        onChange={() => handleCheckboxToggle(index)}
                      />
                      <span className="capitalize">
                        {filter?.label ? (
                          <>{filter?.label}</>
                        ) : (
                          <>
                            {filter?.name?.includes("_")
                              ? `${filter?.name?.replaceAll("_", " ")}`
                              : filter?.name}
                          </>
                        )}
                      </span>

                      <div className={Style.icon}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1em"
                          height="1em"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M7.5 1V14M1 7.5H14"
                            stroke="currentColor"
                            strokeWidth="1.18236"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </label>
                  </div>
                )
              );
            })}
          </div>
        ) : null}
      </div>

      {filters.filter((f) => f.isChecked).length ? (
        <div className={Style.modal_footer}>
          <div className={Style.footer_buttons}>
            <button
              className={`${Style.btn} ${Style.outline}`}
              onClick={() => {
                setSaveFilterName("My Filter");
                onSave([]); // Clear filters in parent
                closeFun(); // Optional: Close popup after clearing
              }}
            >
              Clear Filters
            </button>

            <button
              className={`${Style.btn} ${Style.w_100}`}
              onClick={handleSubmit}
              disabled={filters === data}
            >
              Apply Filter
            </button>
          </div>
        </div>
      ) : null} */}
      {/* <div className="p-5 bg-white rounded-xl shadow-lg"> */}
      {/* Search Input */}
      {!saveFilterOff &&
        <div className="border-gray-200">
          <div className="bg-white relative rounded-lg w-full border border-[#E1E4EA] shadow-[0_1px_2px_0_rgba(10,13,18,0.05)]">
            <div className="relative flex items-center px-3 py-2 gap-2">
              <SearchLg />
              <input
                type="text"
                placeholder="Search"
                className="flex-1 text-gray-500 text-base outline-none bg-transparent"
                value={searchedValue}
                onChange={(e) => setSearchedValue(e.target.value)}
                onFocus={() => setSaveFilterIs(true)}
                onBlur={() => setTimeout(() => setSaveFilterIs(false) , 100)}
              />
              <div className="flex items-center p-1 border border-[#E1E4EA] rounded text-[#717680] text-[12px] font-medium">
                ⌘K
              </div>
            </div>
            {saveFilterIs && (
              <div className={Style.myFilter__wrap}>
                {searchResult?.length ? (
                  searchResult.map((ele, idx) => {
                    return (
                      <div
                        className={`${Style.myFilter__items} ${saveFilterName == ele?.filter_name
                            ? Style.isActive
                            : ""
                          }`}
                        key={ele.id || idx}
                        onClick={() => {
                          console.log("Test")
                          handleSaveFilterChange(
                            ele?.config_filters,
                            ele?.filter_name,
                            ele?.id
                          );
                          setSearchedValue(ele?.filter_name)
                          setSaveFilterIs(false);
                          setSaveFilterID(ele?.id);
                        }}
                      >
                        <p>{ele.filter_name}</p>
                      </div>
                    );
                  })
                ) : (
                  <div className={Style.myFilter__items}>
                    <DataNotFound
                      title={"Filter"}
                      className={Style.noDataFound}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      }

      {/* Filters Header */}
      <div className="border-gray-200">
        <div className="flex items-center justify-between">
          <h2 className="text-[20px] font-semibold text-[#1E1E1E]">
            Filters
          </h2>
          <div className="flex items-center gap-[10px]">
            <button className="text-[14px] font-semibold text-[#999]" onClick={() => {
              setSaveFilterName("My Filter");
              onSave([]); // Clear filters in parent
              closeFun(); // Optional: Close popup after clearing
            }}>
              Clear All
            </button>
            <div className="size-2 rounded-full bg-[#999]" />
            <button className="text-[14px] font-semibold cursor-pointer text-[#0057FB] disabled:cursor-not-allowed disabled:opacity-70" onClick={handleSaveFilter}
              disabled={
                editingFilter
                  ? !isFiltersChanged() // disable if no changes
                  : filters.filter(
                    (f) =>
                      f.value &&
                      (f.field === "search_by_salary"
                        ? f.value[0] || f.value[1]
                        : f.value)
                  ).length === 0
              }>
              Save Filters
            </button>
          </div>
        </div>
      </div>

      {/* Filter Sections divide-y divide-gray-200  */}
      <div className="overflow-hidden overflow-y-auto min-h-[470px]">
        {/* Name */}

        {filters.map((filter, index) => {
          const {Icon} = filter
          return (
            <div key={index} className={`border ${index == filters?.length - 1 ? "" : "border-b-0"} px-[16px] flex flex-col gap-[16px] py-[16px] border-[#DFDFDF] bg-white hover:bg-gray-50 transition-colors cursor-pointer`} onClick={() => handleCheckboxToggle(index)}>
              <div
                className="w-full flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-[10px]">
                  {Icon ? <Icon /> : <List />}
                  <span className="text-[14px] font-[500] text-[#0E121B]">
                    {filter?.label ? (
                      <>{filter?.label}</>
                    ) : (
                      <>
                        {filter?.name?.includes("_")
                          ? `${filter?.name?.replaceAll("_", " ")}`
                          : filter?.name}
                      </>
                    )}
                  </span>
                </div>
                <div className="flex items-center gap-[5px]">
                  {(filter?.value != "" && filter?.value != [] && filter?.value != ["", ""] && filter?.value) ?
                    <button
                      className="text-[14px] font-medium text-[#999] hover:text-gray-700"
                      onClick={(e) => {
                        e.stopPropagation();
                        clearSingleFilter(index)
                      }}
                    >
                      Clear
                    </button>
                    :
                    null
                  }
                  <ChevronDown className={`size-4 text-[#000] transition-transform ${filter.isChecked ? 'rotate-180' : 'rotate-0'}`} />
                </div>
              </div>

              {filter.isChecked && (
                <div className="p-[10px] flex flex-col gap-[20px] bg-[#F3F3F3] rounded-[8px]">
                  {filter?.selectedOpt == "between" ? (
                    <>
                      <div className="" onClick={(e) => { e.stopPropagation(); }}>
                        <input
                          type={filter?.betweenType}
                          value={filter.value[0] || ""}
                          onChange={(e) => {
                            console.log("EEE", e);
                            console.log("val", e.target.value);
                            handleBetweenChange(index, 0, e.target.value)
                          }
                          }
                          max={
                            filter.betweenType === "date"
                              ? getToday()
                              : undefined
                          }
                          placeholder={`Min ${filter?.label
                            ? filter?.label
                            : filter?.name?.includes("_")
                              ? `${filter?.name?.replaceAll("_", " ")}`
                              : filter?.name
                          }`}
                          className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium"
                        />
                      </div>
                      <div className="" onClick={(e) => { e.stopPropagation(); }}>
                        <input
                          type={filter?.betweenType}
                          value={filter.value[1] || ""}
                          min={
                            filter.betweenType === "date"
                              ? getNextDate(filter.value[0])
                              : undefined
                          }
                          max={
                            filter.betweenType === "date"
                              ? getToday()
                              : undefined
                          }
                          onChange={(e) =>
                            handleBetweenChange(index, 1, e.target.value)
                          }
                          placeholder={`Max ${filter?.label
                              ? filter?.label
                              : filter?.name?.includes("_")
                                ? `${filter?.name?.replaceAll("_", " ")}`
                                : filter?.name
                            }`}
                          className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium"
                        />
                      </div>
                    </>
                  ) :
                    <div className="" onClick={(e) => { e.stopPropagation(); }}>
                      {filter?.type == "dropdown" ? (
                        <>
                          <SelectSearch
                            menuPosition="fixed"
                            value={filter.value}
                            styles={{control : {
                              minHeight: "47px",
                            }}}
                            onChange={(e) =>
                              handleValueChange(index, {
                                target: { value: e },
                              })
                            }
                            multiple={filter?.isMulti || false}
                            placeholder={`Select ${filter?.label
                                ? filter?.label
                                : filter?.name?.includes("_")
                                  ? filter?.name?.replaceAll("_", " ")
                                  : filter?.name
                              }`}
                            options={
                              filter?.dropdown
                                ? filter?.dropdown.map((els) => ({
                                  value: els[filter?.dropdownVal],
                                  label: els[filter?.dropdownKey],
                                }))
                                : departmentList?.map((els) => ({
                                  value: els?.title,
                                  label: els?.title,
                                }))
                            }
                          />
                        </>
                      ) : (
                        <input
                          className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium"
                          type={filter?.type}
                          value={filter.value}
                          onChange={(e) => handleValueChange(index, e)}
                          placeholder={`${filter?.label
                              ? filter?.label
                              : filter?.name?.includes("_")
                                ? `${filter?.name?.replaceAll("_", " ")}`
                                : filter?.name
                            }`}
                        />
                      )}
                    </div>
                  }

                  {/* <input type="text" className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium" /> */}


                  {/* <div className="flex gap-2 items-center">
                    {selectedDesignations.map((designation) => (
                      <div
                        key={designation}
                        className="inline-flex items-center gap-2 bg-blue-100 border border-gray-200 rounded-full px-5 py-2"
                      >
                        <span className="text-sm font-medium text-gray-900">{designation}</span>
                        <button
                          onClick={() => removeDesignation(designation)}
                          className="hover:bg-blue-200 rounded-full p-0.5 transition-colors"
                        >
                          <X className="size-3.5 text-gray-900" strokeWidth={2} />
                        </button>
                      </div>
                    ))}
                  </div> */}
                </div>
              )}
            </div>
          )
        })}

        {/* <div className="border px-[16px] flex flex-col gap-[16px] py-[16px] border-[#DFDFDF] bg-white hover:bg-gray-50 transition-colors cursor-pointer" onClick={() => toggleSection('name')}>
          <div
            className="w-full flex items-center justify-between hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-[10px]">
              <List />
              <span className="text-[14px] font-[500] text-[#0E121B]">Name</span>
            </div>
            <div className="flex items-center gap-[5px]">
              <button
                className="text-[14px] font-medium text-[#999] hover:text-gray-700"
                onClick={(e) => {
                  e.stopPropagation();
                  clearDesignations();
                }}
              >
                Clear
              </button>
              <ChevronDown className={`size-4 text-[#000] transition-transform ${openSections.name ? 'rotate-180' : 'rotate-0'}`} />
            </div>
          </div>

          {openSections.name && (
            <div className="p-[10px] flex flex-col gap-[20px] bg-[#F3F3F3] rounded-[8px]">
              <div className="" onClick={(e) => { e.stopPropagation(); }}>
                <input type="text" className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium" />
              </div>

              <div className="flex gap-2 items-center">
                {selectedDesignations.map((designation) => (
                  <div
                    key={designation}
                    className="inline-flex items-center gap-2 bg-blue-100 border border-gray-200 rounded-full px-5 py-2"
                  >
                    <span className="text-sm font-medium text-gray-900">{designation}</span>
                    <button
                      onClick={() => removeDesignation(designation)}
                      className="hover:bg-blue-200 rounded-full p-0.5 transition-colors"
                    >
                      <X className="size-3.5 text-gray-900" strokeWidth={2} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div> */}

        {/* <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('salary')}
            >
              <div className="flex items-center gap-2.5">
                <CurrencyDollarCircle />
                <span className="text-sm font-medium text-gray-900">Salary</span>
              </div>
              <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.salary ? 'rotate-180' : 'rotate-90'}`} />
            </button>
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('designation')}
            >
              <div className="flex items-center gap-2.5">
                <LayoutAlt />
                <span className="text-sm font-medium text-gray-900">Designation</span>
              </div>
              <div className="flex items-center gap-2">
                <button 
                  className="text-sm font-medium text-gray-500 hover:text-gray-700"
                  onClick={(e) => {
                    e.stopPropagation();
                    clearDesignations();
                  }}
                >
                  Clear
                </button>
                <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.designation ? 'rotate-180' : 'rotate-90'}`} />
              </div>
            </button>
            
            {openSections.designation && (
              <div className="px-4 pb-4 space-y-3 bg-gray-50">
                <div className="bg-white border border-gray-300 rounded px-4 py-3.5">
                  <span className="text-sm font-medium text-gray-900">Developer</span>
                </div>
                
                {selectedDesignations.map((designation) => (
                  <div 
                    key={designation}
                    className="inline-flex items-center gap-2 bg-blue-100 border border-gray-200 rounded-full px-5 py-2"
                  >
                    <span className="text-sm font-medium text-gray-900">{designation}</span>
                    <button 
                      onClick={() => removeDesignation(designation)}
                      className="hover:bg-blue-200 rounded-full p-0.5 transition-colors"
                    >
                      <X className="size-3.5 text-gray-900" strokeWidth={2} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('joiningDate')}
            >
              <div className="flex items-center gap-2.5">
                <CalendarDate />
                <span className="text-sm font-medium text-gray-900">Joining Date</span>
              </div>
              <div className="flex items-center gap-2">
                <button 
                  className="text-sm font-medium text-gray-500 hover:text-gray-700"
                  onClick={(e) => {
                    e.stopPropagation();
                    clearJoiningDate();
                  }}
                >
                  Clear
                </button>
                <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.joiningDate ? 'rotate-180' : 'rotate-90'}`} />
              </div>
            </button>
            
            {openSections.joiningDate && (
              <div className="px-4 pb-4 space-y-3 bg-gray-50">
                <div className="bg-white border border-gray-300 rounded px-4 py-2.5 flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-900">Start</span>
                  <div className="flex items-center gap-4">
                    <input 
                      type="text"
                      placeholder="DD-MM-YYYY"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="text-sm font-medium text-gray-900 uppercase outline-none bg-transparent w-[100px] text-right"
                    />
                    <SmallCalendar />
                  </div>
                </div>

                <div className="bg-white border border-gray-300 rounded px-4 py-2.5 flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-900">End</span>
                  <div className="flex items-center gap-4">
                    <input 
                      type="text"
                      placeholder="DD-MM-YYYY"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="text-sm font-medium text-gray-900 uppercase outline-none bg-transparent w-[100px] text-right"
                    />
                    <SmallCalendar />
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('joiningDate2')}
            >
              <div className="flex items-center gap-2.5">
                <CalendarDate />
                <span className="text-sm font-medium text-gray-900">Joining Date</span>
              </div>
              <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.joiningDate2 ? 'rotate-180' : 'rotate-90'}`} />
            </button>
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('employeeId')}
            >
              <div className="flex items-center gap-2.5">
                <Hash />
                <span className="text-sm font-medium text-gray-900">Employee ID</span>
              </div>
              <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.employeeId ? 'rotate-180' : 'rotate-90'}`} />
            </button>
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('employeeStatus')}
            >
              <div className="flex items-center gap-2.5">
                <Toggle03Right />
                <span className="text-sm font-medium text-gray-900">Employee Status</span>
              </div>
              <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.employeeStatus ? 'rotate-180' : 'rotate-90'}`} />
            </button>
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('phone')}
            >
              <div className="flex items-center gap-2.5">
                <Phone />
                <span className="text-sm font-medium text-gray-900">Phone</span>
              </div>
              <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.phone ? 'rotate-180' : 'rotate-90'}`} />
            </button>
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('phone')}
            >
              <div className="flex items-center gap-2.5">
                <Phone />
                <span className="text-sm font-medium text-gray-900">Phone</span>
              </div>
              <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.phone ? 'rotate-180' : 'rotate-90'}`} />
            </button>
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('phone')}
            >
              <div className="flex items-center gap-2.5">
                <Phone />
                <span className="text-sm font-medium text-gray-900">Phone</span>
              </div>
              <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.phone ? 'rotate-180' : 'rotate-90'}`} />
            </button>
          </div>

          <div className="border-b border-gray-200">
            <button 
              className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-50 transition-colors"
              onClick={() => toggleSection('phone')}
            >
              <div className="flex items-center gap-2.5">
                <Phone />
                <span className="text-sm font-medium text-gray-900">Phone</span>
              </div>
              <ChevronDown className={`size-4 text-gray-900 transition-transform ${openSections.phone ? 'rotate-180' : 'rotate-90'}`} />
            </button>
          </div> */}
      </div>

      {/* Action Buttons */}
      {/* {filters.filter((f) => f.isChecked).length ?
        <div className="flex gap-3">
          <button onClick={closeFun} className="flex-1 px-6 py-2.5 border border-gray-300 rounded-lg text-sm font-semibold text-gray-900 bg-white hover:bg-gray-50 transition-colors">
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="flex-1 px-6 py-2.5 bg-[#0057FB] rounded-lg text-sm font-semibold text-white hover:bg-blue-700 transition-colors"
          >
            Submit
          </button>
        </div>
        :
        null
      } */}
      <div className="flex gap-3">
        <button onClick={closeFun} className="flex-1 px-6 py-[17px] border border-[#1E1E1E] rounded-[8px] text-[16px] font-semibold text-[#0E121B] bg-white hover:bg-gray-50 transition-colors">
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          className="flex-1 px-6 py-[17px] bg-[#0057FB] rounded-[8px] text-[16px] font-semibold text-white hover:bg-blue-700 transition-colors"
        >
          Submit
        </button>
      </div>
      {/* </div> */}
    </LeftSidePopupLayout>
  );
};

export default DynamicFilter;
